<template>
  <div class="header">
    <div class="cont">
      <div class="logo">
        <img src="../../assets/images/公司logo.png" alt="杭州越璋文化传媒有限公司" />
        <div class="gs-title">杭州越璋文化传媒有限公司</div>
      </div>

      <div class="sep"></div>
      <div class="btn_menu" @click="btnMenuClick()">
        <icon name="list" fill="#fff"></icon>
      </div>
      <ul
        ref="HeaderNav"
        class="nav"
        @mouseenter="navMouseIn()"
        @mouseleave="navMouseOut()"
      >
        <li
          class="nav_item"
          :class="{
            nav_item_active: currentIndex === index,
            activeText: currentIndex === index,
          }"
          v-for="(item, index) in navList"
          :key="index"
          @click="navItemClick(index, item)"
        >
          {{ item.name }}
        </li>
      </ul>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      list: ["合计", "", "", 17654.1, 14856.2, "", "", "", "", ""],
      navList: [
        { name: "首页", url: "/" },
        { name: "流量解决方案", url: "/solve" },
        { name: "核心优势", url: "/advantage" },
        { name: "合作模式", url: "/cooperate" },
        { name: "成功案例", url: "/case" },
        { name: "关于我们", url: "/about" },
      ],
      currentIndex: 0,
      activeBorderIndex: -1,
      activeIndex: -1,
    };
  },
  created() {
    var me = this;
    me.getNum();
  },
  mounted() {
    console.log(this.$route.path, "this.$route.path");
    if (this.$route.path !== "/") {
      const res = this.navList.findIndex(
        (item) => item.url === this.$route.path
      );
      if (res !== -1) {
        this.currentIndex = res;
        console.log(this.currentIndex);
      } else {
        this.currentIndex = 0;
      }
    }
  },
  watch: {
    $route: {
      handler(newVal) {
        if (newVal.path !== "/") {
          const res = this.navList.findIndex(
            (item) => item.url === newVal.path
          );
          if (res !== -1) {
            this.currentIndex = res;
            console.log(this.currentIndex);
          } else {
            this.currentIndex = 0;
          }
        }
        // this.navItemClick(newVal, this.navList[newVal]);
      },
    },
  },
  methods: {
    btnMenuClick() {
      var nav = this.$refs.HeaderNav,
        cn = nav.className,
        reg = /\s+show/i;
      nav.className = reg.test(cn) ? cn.replace(reg, "") : cn + " show";
    },
    navMouseOut() {
      var nav = this.$refs.HeaderNav,
        cn = nav.className,
        reg = /\s+show/i;
      reg.test(cn) && (nav.className = cn.replace(reg, ""));
    },
    navMouseIn() {
      var nav = this.$refs.HeaderNav,
        cn = nav.className,
        reg = /\s+show/i;
      !reg.test(cn) && (nav.className = cn + " show");
    },
    navItemClick(index, item) {
      this.localSet("NavIndex", index);
      this.currentIndex = index;
      // 设置要显示下边框的索引
      this.activeBorderIndex = index;
      this.activeIndex = index; // 设置为被点击的项的索引
      // 切换到新的页面，点击的项会有下边框，其他项没有
      this.$router.push({ path: item.url });
    },
    getNum() {
      let newNumList = this.list.filter((value) => {
        if (typeof value === "number") {
          return value.toFixed(1);
        }
      });
      console.log(newNumList);
    },
  },
};
</script>

<style lang="scss" scoped>
.header {
  width: 100%;
  border-bottom: 1px solid #99a6ad;
  background-color: rgba(255, 254, 254);
  position: absolute;
  position: fixed; /* 添加此行以使 header 固定 */
  top: 0;
  z-index: 9999;
  overflow: hidden;
  border-bottom: none; /* 或者 border-bottom: 0; */

  .cont {
    overflow: hidden;
    width: calc(100% - 320px); /* 减去左右各160px的边距 */
    margin: 0 auto;
    // padding: 0 160px; /* 添加内边距以实现左右边距 */
    height: 80px;
    display: flex;
    // max-width: 1200px;
    justify-content: space-between;
    align-items: center;
  }

  .logo {
    flex: 0;
    display: flex;
    justify-content: center;
    align-items: center;
  }

  .logo img {
     width: 50px;
    height: 50px;
    background-size: 100% 100%;
  }

  .logo div {
    width: 300px;
    margin-bottom: 10px;
    font-size: x-large;
    font-weight: 600;
    color: #F20303;
  }

  .sep {
    flex: 1;
  }

  .nav {
    height: 100%;
    display: flex;
    flex: 0;
    justify-content: flex-end;
    align-items: flex-end;
  }

  .btn_menu {
    display: none;
    line-height: 0px;
    padding: 5px;
    border-radius: 3px;
    flex: 0;
  }

  .nav_item {
    position: relative;
    display: inline-block; /* 使元素表现为行内块元素 */
    padding: 0 5%;
    height: 100%;
    font-size: 16px;
    font-family: PingFang SC;
    font-weight: 500;
    line-height: 80px;
    color: #000000;
    white-space: nowrap;
    word-break: keep-all;
    word-wrap: unset;
    cursor: pointer;
  }
  .nav_item.activeText {
    color: #F20303; /* 点击后的字体颜色为蓝色 */
  }
  .nav_item::after {
    content: "";
    position: absolute;
    left: 0;
    bottom: 0;
    width: 100%;
    height: 5px;
    background-color: transparent; /* 边框颜色透明 */
    transition: background-color 0.3s; /* 添加过渡效果，可选 */
  }

  .nav_item:hover::after {
    background-color: #F20303; /* 鼠标悬浮时设置边框颜色 */
    transition: background-color 0.3s; /* 添加过渡效果，可选 */
  }

  .nav_item::before {
    content: "";
    position: absolute;
    bottom: -5px;
    left: 0;
    width: 100%;
    height: 5px;
    background-color: #F20303;
    opacity: 0;
    transition: opacity 0.3s, bottom 0.3s;
    pointer-events: none;
  }

  .nav_item:hover::before,
  .nav_item_active::before {
    opacity: 1;
    bottom: 0;
  }

  .nav_item:hover:hover {
    color: #F20303;
  }

  .nav_item_active,
  .nav_item:visited {
    margin-bottom: -1px;
    border-bottom: 1px solid #fff;
    // background-color: rgba(0, 0, 0, .3);
  }
}

// @media screen and (max-width: 920px) {
//   .header {
//     .nav_item {
//       padding: 0 3%;
//     }
//   }
// }

// @media screen and (max-width: 768px) {
//   .header {
//     .cont {
//       height: 1.5rem;
//     }

//     .logo img {
//       width: 4rem;
//     }
//   }
// }

// @media screen and (max-width: 580px) {
//   .header {
//     .btn_menu {
//       line-height: 0px;
//       display: block;
//       flex: 0;
//     }

//     .btn_menu:hover,
//     .btn_menu:active {
//       background-color: rgba(0, 0, 0, 1);
//     }

//     .nav {
//       display: none;
//       height: auto;
//       position: absolute;
//       right: 5%;
//       top: 1.5rem;
//       flex-direction: column;
//       justify-content: flex-start;
//       align-items: flex-start;
//     }

//     .nav_item {
//       width: 100%;
//       padding: 0 10px;
//       line-height: 1rem;
//       font-size: 0.45rem;
//       background-color: rgba(0, 0, 0, 0.3);
//     }

//     .nav_item_active,
//     .nav_item:visited {
//       background-color: rgba(0, 0, 0, 0.5);
//       border: 0;
//       margin: 0;
//     }

//     .show {
//       display: flex;
//     }
//   }
// }
</style>
